export default __webpack_public_path__ + "static/media/m-assortedmeat.6d1493c0.png";